import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Observable} from 'rxjs';
import {Site} from '../models/site/site';

@Injectable({
  providedIn: 'root'
})
export class SiteService {
  private http = inject(HttpClient);


  apiUrl = '/api/sites';

  public get(siteId: string): Observable<Site> {
    let params = new HttpParams();
    params = params.append('id', siteId);

    return this.http.get <Site>(`${this.apiUrl}`, {params});
  }

  public save(site: Site): Observable<Site> {
    let url = this.apiUrl;

    if (site.id) {
      url = url + '/' + site.id;
      return this.http.put<Site>(url, site);
    } else {
      return this.http.post<Site>(url, site);
    }
  }

  public getByAffiliate(pubId: number, withLinks = false): Observable<Site[]> {
    let params = new HttpParams();

    if (pubId) {
      params = params.append('pub_id', pubId.toString());
    }

    if (withLinks) {
      params = params.append('withLinks', '1');
    }

    return this.http.get<Site[]>(`${this.apiUrl}`, {params});
  }
}
